import { useMemo, useState } from 'react';
import { ALL_JOBS, INITIAL_QUEUE_IDS, INITIAL_TIMELINE } from './mockData';

export function useDispatchBoard() {
  const [queueIds, setQueueIds] = useState(INITIAL_QUEUE_IDS);
  const [timeline, setTimeline] = useState(INITIAL_TIMELINE);

  const jobsCatalog = useMemo(() => {
    const map = {};
    for (const job of ALL_JOBS) {
      map[job.id] = job;
    }
    return map;
  }, []);

  const queue = useMemo(() => queueIds.map((id) => jobsCatalog[id]).filter(Boolean), [jobsCatalog, queueIds]);

  const enrichedTimeline = useMemo(
    () =>
      timeline.map((slot) => ({
        ...slot,
        job: slot.jobId ? jobsCatalog[slot.jobId] || null : null,
      })),
    [timeline, jobsCatalog]
  );

  const assignToSlot = (jobId, slotId) => {
    if (!jobsCatalog[jobId]) return;

    const displacedJobId = timeline.find((slot) => slot.id === slotId)?.jobId;

    setTimeline((prev) => prev.map((slot) => (slot.id === slotId ? { ...slot, jobId } : slot)));
    setQueueIds((prev) => {
      const withoutMoved = prev.filter((id) => id !== jobId);
      if (displacedJobId && displacedJobId !== jobId) {
        if (!withoutMoved.includes(displacedJobId)) {
          return [...withoutMoved, displacedJobId];
        }
      }
      return withoutMoved;
    });
  };

  const unassignFromSlot = (slotId) => {
    const slot = timeline.find((item) => item.id === slotId);
    if (!slot?.jobId) return;
    if (jobsCatalog[slot.jobId]) {
      setQueueIds((prev) => (prev.includes(slot.jobId) ? prev : [...prev, slot.jobId]));
    }
    setTimeline((prev) => prev.map((item) => (item.id === slotId ? { ...item, jobId: null } : item)));
  };

  return {
    queue,
    timeline: enrichedTimeline,
    assignToSlot,
    unassignFromSlot,
  };
}
